import { applyMiddleware, createStore } from "redux";
import Reducers from "../Reducers";
import thunk from "redux-thunk";

export const store = createStore(
  Reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
